$(document).ready(function (){
    $("#form-update-img").on('submit', function (e){
        e.preventDefault()
        //let data = new FormData(this);
        let data = new FormData(this);
        $(".loader_").addClass('loading')
        sendImg("/update-img", data)
    })

    function sendImg(route,data) {
        $.ajax({
            url: route,
            type: 'POST',
            data: data,
            processData: false,   // Evita que jQuery procese los datos
            contentType: false,   // No establecer un contentType predeterminado
            cache: false,
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            success: function (response) {
                $(".loader_").removeClass('loading')
                if (response.type === "success") {
                    Swal.fire({
                        text: response.msg,
                        icon: 'success',
                        confirmButtonText: 'OK'
                    }).then((result) => {
                        if (result.isConfirmed) {
                            location.reload()
                        }
                    });

                }
            }, error: function (errors, xhr, status,) {
                var indices = errors.responseJSON.errors;
                $.each(indices, function (index, value) {
                    $(".item-" + index).html(value)
                });
            }
        });
    }
})
